import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    TextField,
    Typography,
} from "@mui/material";
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import React, { useState } from "react";
import { useText } from "../../main.tsx";

type Props = {
    address: AddressWithPrediction,
    currentPowerConsumption: number,
    currentCostsPerKwh: number,
    onSubmit: (powerConsumption: number, pricePerKwh: number) => void
};

const CustomerInput: React.FC<Props> = ({
    address,
    currentPowerConsumption,
    currentCostsPerKwh,
    onSubmit
}) => {
    const [open, setOpen] = useState<boolean>(false);
    const [tempPowerConsumption, setTempPowerConsumption] = useState<number>(currentPowerConsumption);
    const [tempCostsPerKwh, setTempCostsPerKwh] = useState<number>(currentCostsPerKwh);

    const { t } = useText();

    const openEditor = () => {
        setOpen(true);
    };

    const handleSave = async () => {
        if (tempPowerConsumption !== currentPowerConsumption || tempCostsPerKwh !== currentCostsPerKwh) {
            onSubmit(tempPowerConsumption, tempCostsPerKwh);
        }
        setOpen(false);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Box>
            <Stack
                direction="row"
                alignItems="center"
                spacing={1}
                sx={{ mb: 1 }}
            >
                <LocationOnOutlinedIcon color="primary" opacity={.75} sx={{ stroke: "#F5F5F2" }} />
                <Typography
                    sx={{
                        fontFamily: "IBM Plex Sans, Helvetica",
                        fontSize: 16,
                        opacity: 0.75,
                    }}
                >
                    {address.address}
                </Typography>
            </Stack>
            <Typography variant="h1" sx={{ mb: 1 }}>
                {t('funnel.wizard.customerInput.title')}
            </Typography>
            <Button
                variant="text"
                sx={{
                    p: 0,
                    textDecoration: "underline",
                    fontFamily: '"Sora", sans-serif',
                    fontSize: { xs: 14, sm: 16 },
                }}
                onClick={openEditor}
            >
                {t('funnel.wizard.customerInput.description')}
            </Button>
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
                <DialogTitle>{t('funnel.wizard.customerInput.description')}</DialogTitle>
                <DialogContent>
                    <Box sx={{ mt: 1 }}>
                        <TextField
                            ref={React.createRef<HTMLInputElement>()}
                            label="Jährlicher Stromverbrauch"
                            slots={{ inputLabel: "h3" }}
                            style={{ width: '100%', padding: '8px', marginBottom: '20px', fontSize: '0.95rem' }}
                            type="number"
                            id="yearly-power-consumption"
                            defaultValue={tempPowerConsumption}
                            onChange={(e) => setTempPowerConsumption(Number(e.target.value))}
                            variant="standard"
                        />
                    </Box>
                    <Box sx={{ mt: 1 }}>
                        <TextField
                            ref={React.createRef<HTMLInputElement>()}
                            label="Preis pro Kilowattstunde (kWh)"
                            slots={{ inputLabel: "h3" }}
                            style={{ width: '100%', padding: '8px', marginBottom: '20px', fontSize: '0.95rem' }}
                            type="number"
                            id="price-per-kwh"
                            defaultValue={tempCostsPerKwh}
                            onChange={(e) => setTempCostsPerKwh(Number(e.target.value))}
                            variant="standard"
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Abbrechen</Button>
                    <Button onClick={handleSave} variant="contained">
                        Speichern
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default CustomerInput;
